import { render, staticRenderFns } from "./InfLetterCard.vue?vue&type=template&id=4f7260fe&"
import script from "./InfLetterCard.vue?vue&type=script&lang=js&"
export * from "./InfLetterCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports